import { defineMessages } from "react-intl";

export const authorizeStatusMessages = defineMessages({
  full: {
    defaultMessage: "Full",
    id: "F/JMp6",
    description: "authorize status full",
  },
  partial: {
    defaultMessage: "Partial",
    id: "EojeG7",
    description: "authorize status partial",
  },
  none: {
    defaultMessage: "None",
    id: "EoTI4r",
    description: "authorize status none",
  },
});

export const chargeStatusMessages = defineMessages({
  full: {
    defaultMessage: "Full",
    id: "UIM5bq",
    description: "charge status full",
  },
  partial: {
    defaultMessage: "Partial",
    id: "KPmk40",
    description: "charge status partial",
  },
  overcharged: {
    defaultMessage: "Overcharged",
    id: "ZOamBQ",
    description: "charge status overcharged",
  },
  none: {
    defaultMessage: "None",
    id: "dLIeRH",
    description: "charge status none",
  },
});

export const discountTypeMessages = defineMessages({
  fixed: {
    defaultMessage: "Fixed",
    id: "1/bAgt",
    description: "discount type fixed",
  },
  percentage: {
    defaultMessage: "Percentage",
    id: "+Wm2vY",
    description: "discount type percentage",
  },
  shipping: {
    defaultMessage: "Shipping",
    id: "UVDfTs",
    description: "discount type shipping",
  },
});

export const voucherStatusMessages = defineMessages({
  active: {
    defaultMessage: "Active",
    id: "EGycu/",
    description: "voucher status active",
  },
  expired: {
    defaultMessage: "Expired",
    id: "+470FM",
    description: "voucher status expired",
  },
  scheduled: {
    defaultMessage: "Scheduled",
    id: "qQih8j",
    description: "voucher status scheduled",
  },
});

export const collectionFilterMessages = defineMessages({
  published: {
    defaultMessage: "Published",
    description: "collection filter published",
    id: "UYKEsx",
  },
  hidden: {
    defaultMessage: "Hidden",
    description: "collection filter hidden",
    id: "ufahVh",
  },
});

export const staffMembersStatusMessages = defineMessages({
  active: {
    defaultMessage: "Active",
    description: "staff members status active",
    id: "nG1+Cz",
  },
  deactivated: {
    defaultMessage: "Inactive",
    description: "staff members status deactivated",
    id: "oYV+Ru",
  },
});

export const productTypeMessages = defineMessages({
  digital: {
    defaultMessage: "Digital",
    description: "product type digital",
    id: "SgFE10",
  },
  shippable: {
    defaultMessage: "Shippable",
    description: "product type shippable",
    id: "M61TN/",
  },
});

export const attributeTypesMessages = defineMessages({
  productType: {
    defaultMessage: "Product type",
    id: "jzu97k",
    description: "attribute product type",
  },
  pageType: {
    defaultMessage: "Page type",
    id: "qT0qr/",
    description: "attribute page type",
  },
});

export const paymentMethodTypeMessages = defineMessages({
  card: {
    defaultMessage: "Card",
    id: "UGm9nx",
    description: "payment method type card",
  },
  other: {
    defaultMessage: "Other",
    id: "g1bk+A",
    description: "payment method type other",
  },
});

export const fulfillmentStatusMessages = defineMessages({
  canceled: {
    defaultMessage: "Canceled",
    id: "jiXbx5",
    description: "fulfillment status canceled",
  },
  fulfilled: {
    defaultMessage: "Fulfilled",
    id: "lSOmbK",
    description: "fulfillment status fulfilled",
  },
  refunded: {
    defaultMessage: "Refunded",
    id: "cwjmte",
    description: "fulfillment status refunded",
  },
  refundedAndReturned: {
    defaultMessage: "Refunded and Returned",
    id: "zY1K7Q",
    description: "fulfillment status refunded and returned",
  },
  replaced: {
    defaultMessage: "Replaced",
    id: "epB7b7",
    description: "fulfillment status replaced",
  },
  returned: {
    defaultMessage: "Returned",
    id: "zUHPnm",
    description: "fulfillment status returned",
  },
  waitingForApproval: {
    defaultMessage: "Waiting for Approval",
    id: "L/ZbnW",
    description: "fulfillment status waiting for approval",
  },
});
